import React,{useState, useEffect} from 'react';
import './header.scss';
import ModalContact from './ModalContact';

function Header() {
  const [navClass, setNavClass] = useState("")
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    window.onscroll = function() {
      var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      if(scrollTop>0){
        setNavClass("nav-active")
      }else{
        setNavClass("")
      }
    }
},[])
  return (
    <div className={"header " + navClass}>
      <div className="headrgroup">
        <a href="#banner">
        <div className="logo">
        <img src="images/logo.png" />
        <span>Motion Design</span>
        </div>
        </a>
        <div className="nav-list">
          <a href="#banner">首页</a>
          <a href="#featurebox">课程优势</a>
          <a href="#work-outline">课程大纲</a>
          <a href="#worksbox-title">学员作品</a>
          <a href="#work-title">你的疑惑</a>
          <button onClick={() => setVisible(true)}>报名学习</button>
          <ModalContact
            visible={visible}
            onClose={()=>setVisible(false)}
          />
        </div>
      </div>
    </div>
  );
}

export default Header;
